// extracted by mini-css-extract-plugin
module.exports = {"studentBowsTable":"boegen-module--studentBowsTable--2oi8E","left":"boegen-module--left--eQn_c","bold":"boegen-module--bold--HsIyS","center":"boegen-module--center--3rH-v"};